import { Injectable } from '@angular/core';
import { Event } from 'app/core/models/event.model';
import { take } from 'rxjs';
import { EventService } from '../event/event.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  primaryColor: string;
  secundaryColor: string;
  buttonTextColors: string;
  linkColors: string;
  textColorPrimary: string;
  textColorSecundary: string;
  buttonBackgroundColorPrimary: string;
  buttonBackgroundColorSecundary: string;
  buttonTextColorPrimary: string;
  buttonTextColorSecundary: string;
  focusedButtonBackgroundPrimary: string;
  focusedButtonBackgroundSecundary: string;
  token: string;
  eventSapCode: string;
  errorMessage: string;
  errorCodeMessage: string;
  OkMessage: string;
  okCodeMessage: string;
  lang: string;
  manualLangSelected: boolean = false;
  langAppliedFromUrl: boolean = false;
  event: Event;
  redirectUrl: string;
  constructor(private _event: EventService) { }

  setHtmlLang(internalCode: string) {
    document.documentElement.lang = (internalCode || '').substring(0, 2) || 'es';
  }



  getEventProperties(property: string) {
    switch(property) {
      case 'primaryColor': return this.primaryColor;
      case 'secundaryColor': return this.secundaryColor;
      case 'buttonBackgroundColorPrimary': return this.buttonBackgroundColorPrimary;
      case 'buttonTextColorPrimary': return this.buttonTextColorPrimary;
      case 'textColorPrimary': return this.textColorPrimary;
      case 'textColorSecundary': return this.textColorSecundary;
      case 'buttonTextColorSecundary': return this.buttonTextColorSecundary;
      case 'focusedButtonBackgroundPrimary': return this.focusedButtonBackgroundPrimary;
      case 'focusedButtonBackgroundSecundary': return this.focusedButtonBackgroundSecundary;
      default: return '';
    }
  }

  async getEvent() {
    return new Promise((resolve) => {
      this._event.getEventBySapCode(this.eventSapCode)
      .pipe(take(1))
      .subscribe({
      next: async (event: Event) => {
        this.event = event;
        await this.setRootProperties();
        resolve(true);
      },error: async () => {
        await this.setRootProperties();
        resolve(true);
      }});
    });

  }

  async setRootProperties() {
    return new Promise((resolve) => {
      this.primaryColor = this.event?.primaryColors && this.event?.primaryColors !== '' ? this.event.primaryColors.split(',')[0] : '#F2F2F2';
      this.secundaryColor = this.event?.primaryColors && this.event?.primaryColors !== '' ? this.event.primaryColors.split(',')[1] : '#ffffff'; 
      this.buttonBackgroundColorPrimary = this.event?.buttonBackgroundColors && this.event.buttonBackgroundColors !== '' ? this.event.buttonBackgroundColors.split(',')[0] : '#3949AB';
      this.buttonTextColorPrimary = this.event?.buttonTextColors && this.event?.buttonTextColors!== '' ? this.event.buttonTextColors.split(',')[0] : '#ffffff';
      this.buttonTextColorSecundary = this.event?.buttonTextColors && this.event?.buttonTextColors !== '' ? this.event.buttonTextColors.split(',')[1] : '#263172';
      this.textColorPrimary = this.event?.textColors && this.event.textColors !== '' ? this.event.textColors.split(',')[0] :'rgb(255, 255, 255)';
      this.textColorSecundary = this.event?.textColors && this.event.textColors !== '' ? this.event.textColors.split(',')[1] : '#000000';
      this.focusedButtonBackgroundPrimary = this.event?.focusedButtonBackgroundColors && this.event?.focusedButtonBackgroundColors != '' ? this.event?.focusedButtonBackgroundColors.split(',')[0] : '#ffffff';
      this.focusedButtonBackgroundSecundary = this.event?.focusedButtonBackgroundColors && this.event?.focusedButtonBackgroundColors != '' ? this.event?.focusedButtonBackgroundColors.split(',')[1] : '#ffffff';
      resolve(true);
    });

  }
  
}
